import script from "./concat.vue?vue&type=script&setup=true&lang=js"
export * from "./concat.vue?vue&type=script&setup=true&lang=js"

import "./concat.vue?vue&type=style&index=0&id=480d7516&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480d7516"]])

export default __exports__